export const getsubscriptionPlansURL = '/cart/subscriptions/plans'
export const subscriptionPlanDetailsURL = '/cart/subscriptions/{sub_id}'
export const signupSubscriptionURL = '/cart/subscriptions'
export const updateSubscriptionURL = '/cart/subscriptions'
export const getSubscriptionRenewalsURL = '/cart/subscriptions/{sub_id}/renewals'
export const subscriptionPromoProductsURL = 'content/promo/subscriptions'
